import { EncodeEndpointService } from "@/views/loyalty/shared/endpoint_services/encode-endpoint-service"

export class EncodeService {
    constructor (url) {
        this.encodeEndpointService = new EncodeEndpointService(url)
    }

    async encodeCustomerId (customerId) {
        const text = await this.encodeEndpointService.encodeCustomerId(customerId)
        return `https://t.me/${process.env.VUE_APP_BOT_NAME}?start=${text}`
    }

    async encodeUserNumber (userNumber) {
        const text = await this.encodeEndpointService.encodeUserNumber(userNumber)
        return `https://t.me/${process.env.VUE_APP_BOT_NAME}?start=${text}`
    }
}
